const mutations = {
  setAdminGames(state, payload) {
    state.adminGames = payload;
  },
  setPlayBackground(state, payload) {
    state.playBackground = payload;
  },
  setPlayGame(state, payload) {
    state.playGame = payload;
  },
  setFlipmasterSettings(state, payload) {
    state.flipmasterSettings = payload;
  },
  setSelectedProviders(state, payload) {
    state.selectedProviders = payload;
  },
};

export default mutations;
